export default "__VITE_ASSET__beBzcVB3__"